/*eslint-disable*/

import actions from './actions';

const { SEARCH_HEADER_SUCCESS, SEARCH_HEADER_ERR, ADD_SELECTED_USER } = actions;

const initialState = {
  users: [],
  filteredData: [],
  error: null,
};

const headerSearchReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SEARCH_HEADER_SUCCESS:
      return {
        ...state,
        filteredData: data,
        error: null,
      };
    case SEARCH_HEADER_ERR:
      return {
        ...state,
        error: err,
      };
    case ADD_SELECTED_USER:
      return {
        ...state,
        users: data,
      };
    default:
      return state;
  }
};

export { headerSearchReducer };

